import { Pipe, PipeTransform } from '@angular/core';
import { Settings } from '../settings.class';

@Pipe({
  name: 'hectoPinIcon'
})
export class HectoPinIconPipe implements PipeTransform {
  transform(hectoPin: any): any {
    const svg = Settings.getHecto(hectoPin.waynumber, hectoPin.hectometre, (hectoPin.direction ?? hectoPin.letter));
    return {
      url: 'data:image/svg+xml;charset=UTF-8,' + encodeURIComponent(svg),
      anchor: { x: 16, y: 16 },
    };
  }
} 